import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _isObjectLike from "lodash/isObjectLike";
import _reduce from "lodash/reduce";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.number.max-safe-integer.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.string.replace-all.js";
import React from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// Function to generate unique id numbers.
var counter = 1;
function resetUID() {
  counter = 1;
}
function generateUID(prefix) {
  counter = (counter + 1) % Number.MAX_SAFE_INTEGER; // Prevent crazy overflows by wrapping.
  if (prefix) {
    return "".concat(prefix, "-").concat(counter);
  }
  return "".concat(counter);
}
function nodeIsChildOf(node, parent) {
  var nodeParent = node.parentNode;
  if (!nodeParent) {
    return false;
  }
  if (nodeParent.isSameNode(parent)) {
    return true;
  }
  return nodeIsChildOf(nodeParent, parent);
}
function formatCustomAttribute(text) {
  return text.replace(' ', '_').toLowerCase().trim();
}

// Makes a cancelable promise so that they can be cancelled on unmount.
function makeCancelable(promise) {
  /* eslint-disable prefer-promise-reject-errors */
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled = true;
    }
  };
}

/**
 * Replace the tokens in a string of text
 * @param {string} text   The text to replace tokens in.
 * @param {object} tokens An object with keys of the tokens to replace
 *                        and values of the replacements.
 * @param {boolean} join  Whether or not to join the parts back together as a string.
 * @param {RegExp} format Regex to look for tokens. Default is starting with !, @, %, Or token as [token].
 */
function replaceTokens(text, tokens) {
  var join = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /([%@!]\w+|\[[\w:]+\])/g;
  if (!text) {
    return '';
  }
  var textParts = text.split(format);
  var replacedTextParts = textParts.map(function (value) {
    return value in tokens ? tokens[value] : value;
  });

  // If we should join the parts back together as strings.
  if (join) {
    return replacedTextParts.join('');
  }
  return replacedTextParts;
}

/**
 * From Applanga JS - parse strings with tokens.
 * @param {string} text                 The text to replace tokens in.
 * @param {object} interpolationParams  An object with keys of the tokens to replace
 *                                      and values of the replacements.
 */
function parseInterpolationParams(text, interpolationParams) {
  if (!text) {
    return '';
  }
  Object.keys(interpolationParams).forEach(function (param) {
    var variableTemplate = "{{".concat(param, "}}");
    text = text.replace(new RegExp(variableTemplate, 'g'), interpolationParams[param]);
  });
  return text;
}

/**
 * Check if link title and text match. Return undefined if they match.
 * @param {string} text  Link text.
 * @param {string} title Link title.
 */
function getLinkTitleText(text, title) {
  if (!title) {
    return undefined;
  }
  return title.toLowerCase() !== text.toLowerCase() ? title : undefined;
}
function isEmptyContent(content) {
  if (!content) return true;
  if (typeof content === 'string') {
    return content.trim() === '';
  }
  if (Array.isArray(content)) {
    return content.every(function (item) {
      return isEmptyContent(item);
    });
  }

  // Handle the custom JSON structure
  var node = content;

  // Check text content if it exists
  if (node.text && node.text.trim() !== '') {
    return false; // Has non-empty text, so not empty
  }

  // Check if it's a void element - these are valid content
  var voidElements = ['img', 'hr'];
  if (node.type && voidElements.includes(node.type)) {
    return false; // Void elements are valid content
  }

  // Check children recursively if they exist
  if (node.children && node.children.length > 0) {
    return node.children.every(function (child) {
      return isEmptyContent(child);
    });
  }
  return true;
}

/**
 * Returns children as html element.
 * @param {node} children Children node.
 * @param {string} Element String of html element to wrap item with.
 * @param {boolean} noWrap rule to determine whether to wrap text children in fragment instead of Element
 */
var dangerousHTML = function dangerousHTML(children) {
  var Element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  var noWrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return React.Children.map(children, function (item) {
    if ( /*#__PURE__*/React.isValidElement(item)) {
      return item;
    } else if (noWrap && item && typeof item === 'string') {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: item
      });
    } else if (typeof item === 'string' || typeof item === 'number') {
      return /*#__PURE__*/_jsx(Element, {
        dangerouslySetInnerHTML: {
          __html: item + ''
        }
      });
    } else {
      return null;
    }
  });
};

/**
 * Format a distance string with the unit of measure
 *
 * @param {number} distanceInMiles distance in miles
 * @param {string} unit formatted unit: km (default) or miles
 *
 * @return {string}
 */

function distance(distanceInMiles) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'km';
  var units = {
    miles: {
      conversionFactor: 1,
      label: 'mi.'
    },
    km: {
      conversionFactor: 1.60934,
      label: 'km'
    }
  };

  // Fall back to km if the unit specified is not found.
  var unitInfo = unit in units ? units[unit] : units.km;
  var distanceInUnit = (distanceInMiles * unitInfo.conversionFactor).toFixed(2);
  return "".concat(distanceInUnit, " ").concat(unitInfo.label);
}
var getDurationFromMs = function getDurationFromMs(milliseconds) {
  var sec = Math.floor(milliseconds / 1000);
  var hrs = Math.floor(sec / 3600);
  sec -= hrs * 3600;
  var min = Math.floor(sec / 60);
  sec -= min * 60;
  var secStr = '' + sec;
  secStr = ('00' + secStr).substring(secStr.length);
  if (hrs > 0) {
    var minStr = '' + min;
    minStr = ('00' + minStr).substring(minStr.length);
    return hrs + ':' + minStr + ':' + secStr;
  } else {
    return min + ':' + secStr;
  }
};
function getBrowser() {
  // Browser checks based on https://github.com/mbasso/react-browser-detection.

  var isGoogleBot = navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1;
  // eslint-disable-next-line
  var isIE = /*@cc_on!@*/false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isOpera = !!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isChrome = !isGoogleBot && !isEdge && !isOpera && !!window.chrome && (!!window.chrome.webstore || navigator.vendor.toLowerCase().indexOf('google inc.') !== -1);
  var isSafari = !isChrome && navigator.userAgent.toLowerCase().indexOf('safari') !== -1;
  return {
    isGoogleBot: isGoogleBot,
    isIE: isIE,
    isEdge: isEdge,
    isOpera: isOpera,
    isChrome: isChrome,
    isSafari: isSafari
  };
}
function stripTags(stringWithTags) {
  return stringWithTags.replace(/<[^>]+>/g, '');
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function escapeHTML(html) {
  if (!html) {
    return '';
  }
  return html.replace(/[&<>\"#'"]/g, function (char) {
    switch (char) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&apos;';
      default:
        return char;
    }
  });
}
/* eslint-enable @typescript-eslint/no-explicit-any */

function isWWImage(src) {
  return !!src && /\/assets-proxy\//i.test(src);
}

// Check if the image has a Fastly param
function doesWWImageHaveParam(src, param) {
  if (!isWWImage(src)) {
    return false;
  }
  var searchParams = src ? new URLSearchParams(new URL(src).search) : false;
  return searchParams && searchParams.has(param);
}

// Merge newSearchParams with existing query params in the url
function mergeSearchParams(url, newSearchParams) {
  if (!url || !newSearchParams) {
    return url;
  }
  var urlObj = new URL(url);
  var existingParams = urlObj.searchParams;
  var newSearchParamsArray = Array.from(newSearchParams.entries());

  // Iterate over the array
  for (var i = 0; i < newSearchParamsArray.length; i++) {
    var _newSearchParamsArray = _slicedToArray(newSearchParamsArray[i], 2),
      _key = _newSearchParamsArray[0],
      value = _newSearchParamsArray[1];
    if (value === '') {
      existingParams.delete(_key);
    } else {
      existingParams.set(_key, value);
    }
  }
  urlObj.search = existingParams.toString();
  return urlObj.toString();
}
function getOptimizedCloudinaryUrl(imgSrc, transformations) {
  var overrideWidthHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Skip if a non-string is passed in
  if (typeof imgSrc !== 'string') {
    return imgSrc;
  }
  var src = imgSrc ? imgSrc.trim() : imgSrc;

  // Skip if this is not on a WW image server, is an svg,
  // Or already has q_auto, w_ or h_ attributes,
  if (!src || !(/\/assets-proxy\//i.test(src) || src.includes('cdn.ww.com')) || src.indexOf('fl_sanitize') > -1 || src.indexOf('q_auto') > -1 || !overrideWidthHeight && src.match(/w_[0-9]{1,5}/) || !overrideWidthHeight && src.match(/h_[0-9]{1,5}/)) {
    return src;
  }
  var isVideo = src.indexOf('/video/upload') > -1;
  var existingSearchParams = new URLSearchParams(new URL(src).search);
  var newSearchParams = new URLSearchParams();

  // Use Fastly width and height rather than Cloudinary's w_ and h_
  if (transformations && transformations.width) {
    newSearchParams.append('width', "".concat(transformations.width));
  }
  if (transformations && transformations.height) {
    newSearchParams.append('height', "".concat(transformations.height));
  }

  // Always add auto=webp for images, except those with format=png8, where it undoes compression
  if (!isVideo && existingSearchParams.get('format') !== 'png8') {
    newSearchParams.append('auto', 'webp');
  }

  // Use Fastly optimize=medium rather than Cloudinary's q_auto
  if (!existingSearchParams.has('optimize')) {
    newSearchParams.append('optimize', 'medium');
  }
  var url = mergeSearchParams(src, newSearchParams);
  return url;
}
function toPlainText(label) {
  return stripTags(richTextJSONToPlainText(label));
}
function isRichTextJSON(str) {
  if (typeof str !== 'string') {
    return false;
  }
  // All RichText JSON starts with "[{", so check that
  // first for better performance than full JSON parse.
  if (!str.startsWith('[{')) {
    return false;
  }
  return isJSON(str);
}

/**
 * Determine if string is JSON
 */
function isJSON(str) {
  if (typeof str !== 'string') {
    return false;
  }
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 * Return human-readable text from JSON, if JSON
 */
function richTextJSONToPlainText(jsonString) {
  if (!isRichTextJSON(jsonString)) {
    return jsonString;
  }
  var parsedData = JSON.parse(jsonString || '');
  // Get all values from JSON whose key is 'text'.
  return getPropertyRecursive(parsedData, 'text').map(function (str) {
    return typeof str === 'string' ? str.trim() : '';
  }).join(' ');
}

// Recursively traverse object to get all values with specified key.
/* eslint-disable @typescript-eslint/no-explicit-any */
function getPropertyRecursive(obj, prop) {
  return _reduce(obj, function (result, value, key) {
    if (key === prop) {
      result.push(value);
    } else if (_isObjectLike(value)) {
      return result.concat(getPropertyRecursive(value, prop));
    }
    return result;
  }, []);
}
export function containsBlockTags(content) {
  var blockTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];
  try {
    if (isRichTextJSON(content)) {
      // Check for heading tags at top level
      return blockTags.some(function (tag) {
        return content && content.includes("\"type\":\"".concat(tag, "\""));
      });
    }
  } catch (error) {
    console.error('Invalid JSON string:', error);
    return false;
  }
  return false;
}

// Filter Content for Heading Tags and Replace with Spans
export function sanitizeContent(content) {
  var headingTextAdjustment = content;
  try {
    if (isRichTextJSON(content)) {
      var jsonObject = JSON.parse(content);
      var headingIsEmpty = isEmptyContent(jsonObject);
      if (headingIsEmpty) {
        return headingTextAdjustment = '';
      } else {
        // Convert heading tags to span
        var headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];
        var hasHeadingTags = headingTags.some(function (headingTag) {
          return content && content.includes("\"type\":\"".concat(headingTag, "\""));
        });
        var replacementString = '"type":"span"';
        hasHeadingTags && headingTags.forEach(function (headingTag) {
          headingTextAdjustment = headingTextAdjustment && headingTextAdjustment.replaceAll("\"type\":\"".concat(headingTag, "\""), replacementString);
        });
      }
    }
  } catch (error) {
    console.error('Invalid JSON string:', error);
    return headingTextAdjustment; // Return the original string if parsing fails
  }
  return headingTextAdjustment;
}

// Remove Empty Heading Tags from String, and update any heading tag or p tag nested within another to a Span tag
export function processRichTextContent(jsonString) {
  try {
    // Return early if not a RichText JSON string
    if (!isRichTextJSON(jsonString)) {
      return jsonString;
    }

    // Parse the JSON string
    var parsedData = JSON.parse(jsonString);

    // Recursive function to process the content
    var processContent = function processContent(data) {
      var isNested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (Array.isArray(data)) {
        // Process each item
        return data.map(function (item) {
          return processContent(item, isNested);
        });
      } else if (_typeof(data) === 'object' && data !== null) {
        var _data$type;
        // Early return for empty anchor tags
        if (data.type === 'a' && isEmptyContent(data.children)) {
          return {
            type: 'span',
            children: data.children
          };
        }

        // Handle header tags
        if ((_data$type = data.type) !== null && _data$type !== void 0 && _data$type.startsWith('h')) {
          var children = data.children || [];
          // Process all children first
          var processedChildren = children.map(function (child) {
            var _child$type;
            if ((_child$type = child.type) !== null && _child$type !== void 0 && _child$type.startsWith('h') || child.type === 'p') {
              return _objectSpread(_objectSpread({}, child), {}, {
                type: 'span'
              });
            }
            return processContent(child, true);
          });

          // Check if there's any meaningful text content
          var hasTextContent = function hasTextContent(children) {
            return children.some(function (child) {
              if (typeof child.text === 'string' && child.text.trim() !== '') {
                return true;
              }
              if (child.children) {
                return hasTextContent(child.children);
              }
              return false;
            });
          };
          var hasTextContentResult = hasTextContent(processedChildren);
          var shouldConvertToSpan = isNested || !hasTextContentResult;
          return shouldConvertToSpan ? {
            type: 'span',
            children: processedChildren
          } : _objectSpread(_objectSpread({}, data), {}, {
            children: processedChildren
          });
        }

        // Process other objects
        if (data.children) {
          var _processedChildren = processContent(data.children, isNested);
          data = _processedChildren !== data.children ? _objectSpread(_objectSpread({}, data), {}, {
            children: _processedChildren
          }) : data;
        }
        return data;
      }
      return data;
    };

    // Process the parsed data once
    var cleanedData = processContent(parsedData);

    // Convert back to JSON string
    return JSON.stringify(cleanedData);
  } catch (error) {
    console.error('Invalid JSON string:', error);
    return jsonString; // Return the original string if parsing fails
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */

var Utility = {
  dangerousHTML: dangerousHTML,
  doesWWImageHaveParam: doesWWImageHaveParam,
  distance: distance,
  resetUID: resetUID,
  generateUID: generateUID,
  getBrowser: getBrowser,
  getLinkTitleText: getLinkTitleText,
  getOptimizedCloudinaryUrl: getOptimizedCloudinaryUrl,
  isWWImage: isWWImage,
  nodeIsChildOf: nodeIsChildOf,
  formatCustomAttribute: formatCustomAttribute,
  makeCancelable: makeCancelable,
  replaceTokens: replaceTokens,
  parseInterpolationParams: parseInterpolationParams,
  getDurationFromMs: getDurationFromMs,
  stripTags: stripTags,
  toPlainText: toPlainText,
  escapeHTML: escapeHTML,
  sanitizeContent: sanitizeContent,
  processRichTextContent: processRichTextContent,
  isEmptyContent: isEmptyContent,
  containsBlockTags: containsBlockTags
};
export default Utility;